<template>
  <v-select
    clearable
    v-model="kartTipi"
    :items="itemsKartTipi"
    item-text="name"
    item-value="value"
    :label="$t('Card-Type')"
    hide-details=""
  >
  </v-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      itemsKartTipi: [
        {
          name: this.$t('None-v2'),
          value: 0,
        },
        {
          name: this.$t('With-Corporate-Card'),
          value: 1,
        },
        {
          name: this.$t('With-Client-Card'),
          value: 2,
        },
      ],
    };
  },
  computed: {
    kartTipi: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>

<style>
</style>